import {
  Component,
  ViewChild,
  ViewContainerRef,
  ComponentRef,
  Type,
  EventEmitter,
  Output,
  Input,
  OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Modal } from 'bootstrap';

@Component({
  selector: 'app-confirmation-modal-with-dynamic-component',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirmation-modal-with-dynamic-component.component.html'
})
export class ConfirmationModalWithDynamicComponent implements OnDestroy {
  @ViewChild('dynamicContainer', { read: ViewContainerRef, static: true })
  dynamicContainer!: ViewContainerRef;

  private componentRef?: ComponentRef<any>;
  private modalInstance?: Modal;
  private closeValue: boolean = false;

  @Input() confirmButtonText = 'Confirm';
  @Input() cancelButtonText = 'Cancel';
  @Input() title = 'Confirmation';
  @Input() modalSize: 'sm' | 'lg' | 'xl' | 'fullscreen' | '' = '';
  @Input() modalId: string = 'dynamicCompConfirmationModal';

  @Output() onClose = new EventEmitter<boolean>(); // NOSONAR

  loadComponent<T>(component: Type<T>, data?: Partial<T>) {
    this.dynamicContainer.clear();
    this.componentRef = this.dynamicContainer.createComponent(component);
    if (data) Object.assign(this.componentRef.instance, data);

    const modalElement = document.getElementById(this.modalId);
    if (modalElement) {
      if (this.modalInstance) {
        this.modalInstance.dispose();
      }

      this.modalInstance = new Modal(modalElement, {
        backdrop: 'static',
        keyboard: false,
      });

      const onHidden = () => {
        this.onClose.emit(this.closeValue);
        this.componentRef?.destroy();
        this.modalInstance?.dispose();
        this.modalInstance = undefined;
        modalElement.removeEventListener('hidden.bs.modal', onHidden);
      };

      modalElement.addEventListener('hidden.bs.modal', onHidden);

      this.modalInstance.show();
    }
  }

  onConfirm() {
    this.closeValue = true;
    this.modalInstance?.hide();
  }

  onCancel() {
    this.closeValue = false;
    this.modalInstance?.hide();
  }

  ngOnDestroy() {
    this.modalInstance?.hide(); // Safe fallback
  }
}
